module.exports = __webpack_public_path__ + "static/media/main.15202752.png";